import { useNavigate } from "react-router-dom";
import Button from "../../../component/Button";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

export const Section4 = () => {
  const navigate = useNavigate();
  const isMobile = useResponsiveMobile(900);
  return isMobile ? (
    <section
      className="w-full *:py-[60px] px-[60px] flex justify-center items-center flex-col gap-8 "
      style={{
        backgroundImage: "url('/assets/images/home/bg_gradient_mobile.png')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        // backgroundPosition: "center",
      }}
    >
      <div className="flex flex-col gap-8  w-full ">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-3 justify-center items-center">
            <img
              loading="lazy"
              src="/assets/images/home/fractions_mobile.png"
              alt="fraction"
              className="w-[68px] h-[108px]"
            />
            <span className="text-white font-normal text-center text-[28px]">
              직접 구축 대비 <br />
              절감된 비용으로
            </span>
          </div>
          <span className="font-normal text-white text-base text-center">
            결제·정산 운영에 필요한 <br />
            핵심 기능을 바로 사용하세요.
          </span>
        </div>
        <Button
          id="btn-bottom-apply"
          onClick={() => {
            navigate("/inquiry-form?type=adoption");
          }}
          size="sm"
          className="
        px-8
        md:hidden
          self-center
          w-fit
        h-[48px]
        md:h-20
        md:text-button
        rounded-[70px]
        text-[16px]
        
    border-[3px] border-transparent
    [background-origin:border-box]
    [background-clip:padding-box,border-box]
    bg-[linear-gradient(#fff,#fff),linear-gradient(90deg,#0079FF_0%,#00FF44_56.09%,#FFC400_100%)]
    text-[#0079FF]
  "
        >
          품 도입문의
        </Button>
      </div>
    </section>
  ) : (
    <section
      className="py-20 flex justify-center items-center flex-col gap-8 px-[120px] w-full"
      style={{
        backgroundImage: "url('/assets/images/home/bg_gradient.webp')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        // backgroundPosition: "center",
      }}
    >
      <div className="flex flex-row justify-between max-w-[1200px] w-full items-center gap-5">
        <div className="flex flex-row gap-8 items-center">
          <img
            loading="lazy"
            src="/assets/images/home/fractions.svg"
            alt="fraction"
            className="w-[79px] h-[64px]"
          />
          <div className="flex flex-col gap-1">
            <span className="text-[#FFF] font-bold text-[36px]">
              직접 구축 대비 절감된 비용으로
            </span>
            <span className="text-[20px] font-normal text-[#FFF]">
              결제·정산 운영에 필요한 핵심 기능을 바로 사용하세요.
            </span>
          </div>
        </div>
        <Button
          id="btn-bottom-apply"
          onClick={() => {
            navigate("/inquiry-form?type=adoption");
          }}
          size="sm"
          className="
        px-8
        h-[48px]
        md:h-14
        md:text-button
        rounded-[70px]
        text-[16px]
        
    border-[3px] border-transparent
    [background-origin:border-box]
    [background-clip:padding-box,border-box]
    bg-[linear-gradient(#fff,#fff),linear-gradient(90deg,#0079FF_0%,#00FF44_56.09%,#FFC400_100%)]
    text-[#0079FF]
  "
        >
          품 도입문의
        </Button>
      </div>
    </section>
  );
};
